/* eslint-disable yola/react/require-default-props */
import React, { forwardRef } from 'react';
import Option from './components/option';
import SingleValue from './components/single-value';
import Placeholder from './components/placeholder';
import Input from './components/input';
import ValueContainer from './components/value-container';
import BaseSelect from '../base-select';
import { APPEARANCES, SIZES } from '../base-select/constants';
import noop from '../../../utils/noop';

const components = {
  Option,
  SingleValue,
  Placeholder,
  Input,
  ValueContainer,
};

const LanguageSelect = forwardRef(
  (
    {
      appearance = APPEARANCES.default,
      clearable = false,
      defaultValue = undefined,
      defaultInputValue = '',
      disabled = false,
      id = undefined,
      invalid = false,
      name = undefined,
      onBlur = noop,
      onChange,
      onCreateOption = undefined,
      filterOptionsFunction = undefined,
      onFocus = noop,
      onInputChange = noop,
      options,
      placeholder = 'Select item',
      preventOverflow = false,
      openMenuOnFocus = false,
      menuPlacement = 'auto',
      size = SIZES.small,
    },
    ref
  ) => (
    <BaseSelect
      ref={ref}
      appearance={appearance}
      clearable={clearable}
      components={components}
      disabled={disabled}
      id={id}
      invalid={invalid}
      name={name}
      defaultValue={defaultValue}
      defaultInputValue={defaultInputValue}
      onBlur={onBlur}
      onChange={onChange}
      onCreateOption={onCreateOption}
      filterOptionsFunction={filterOptionsFunction}
      onFocus={onFocus}
      onInputChange={onInputChange}
      options={options}
      placeholder={placeholder}
      preventOverflow={preventOverflow}
      openMenuOnFocus={openMenuOnFocus}
      menuPlacement={menuPlacement}
      size={size}
    />
  )
);

LanguageSelect.displayName = 'LanguageSelect';

export default LanguageSelect;
